export default __webpack_public_path__ + "h6.png";